import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TFunction } from 'i18next';
import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { Icon } from '../../icon/icon';
import { GcpOptimizationStatus } from './place-markers-state';

interface GcpOptimizationStatusIconProps {
  optimizationStatus: GcpOptimizationStatus;
  t: TFunction;
}

export const GcpOptimizationStatusIcon: React.FC<GcpOptimizationStatusIconProps> = ({
  optimizationStatus,
  t,
}) => {
  const theme = useTheme();

  const iconConfig = useMemo<{ icon: IconProp; color: string; title: string } | null>(() => {
    switch (optimizationStatus) {
      case 'OPTIMIZED':
        return {
          icon: ['fas', 'check-circle'],
          color: theme.color.green,
          title: t('aligner.table.optimizationStatus.optimized', { ns: 'cloudProcessing' }),
        };
      case 'UNOPTIMIZED':
        return {
          icon: ['fas', 'exclamation-triangle'],
          color: theme.color.brand.dark,
          title: t('aligner.table.optimizationStatus.unoptimized', { ns: 'cloudProcessing' }),
        };
      case 'HIGH_ERROR':
        return {
          icon: ['fas', 'exclamation-triangle'],
          color: theme.color.red,
          title: t('aligner.table.optimizationStatus.highError', { ns: 'cloudProcessing' }),
        };
      case 'LOW_COUNT':
        return {
          icon: ['fas', 'info-circle'],
          color: theme.color.blue,
          title: t('aligner.table.optimizationStatus.lowCount', { ns: 'cloudProcessing' }),
        };
      case 'NONE':
        return null;
      default:
        return null;
    }
  }, [optimizationStatus, theme, t]);

  if (!iconConfig) {
    return null;
  }

  return <Icon color={iconConfig.color} icon={iconConfig.icon} title={iconConfig.title} />;
};
